module.exports = __webpack_public_path__ + "static/media/Color.10fcb63c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Assurant/Color.png
// module id = 120
// module chunks = 0